import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'white', // Default text color
          '&:hover': {
            color: 'black', // Text color on hover
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 48,
        },
        containedInherit: {
          color: theme?.palette?.grey[800],
          boxShadow: theme?.customShadows?.z8,
          '&:hover': {
            backgroundColor: theme?.palette?.grey[400],
            color: 'black', // Text color on hover
          },
        },
        containedPrimary: {
          boxShadow: theme?.customShadows?.primary,
          color: 'white', // Text color for primary button
          '&:hover': {
            color: 'black', // Text color on hover for primary button
          },
        },
        containedSecondary: {
          boxShadow: theme?.customShadows?.secondary,
          color: 'white', // Text color for secondary button
          '&:hover': {
            color: 'black', // Text color on hover for secondary button
          },
        },
        outlinedInherit: {
          border: `1px solid ${alpha(theme?.palette?.grey[500], 0.32)}`,
          color: 'white', // Text color for outlined button
          '&:hover': {
            backgroundColor: theme?.palette?.action?.hover,
            color: 'black', // Text color on hover for outlined button
          },
        },
        textInherit: {
          color: 'white', // Text color for text button
          '&:hover': {
            backgroundColor: theme?.palette?.action?.hover,
            color: 'black', // Text color on hover for text button
          },
        },
      },
    },
  };
}
